
import axios from "axios";

const authBaseURL = process.env.VUE_APP_FIREBASE_AUTH_BASE_URL;
const firebaseApiKey = process.env.VUE_APP_FIREBASE_API_KEY;

if (!authBaseURL || !firebaseApiKey) {
  throw new Error("Missing Firebase auth environment variables");
}

const authApi = axios.create({
    baseURL: authBaseURL,

   params:{
        key: firebaseApiKey
    }
    
})


export default authApi
